module.exports = __webpack_public_path__ + "1954261351f3b33854926e2c7e90cf97.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/belt-black-s.png
// module id = 1233
// module chunks = 0